export default {
  accepted: 'Prihvaćeno',
  accessRequestDate: 'Datum zahtjeva za pristup',
  confirmUserWillBeSystemAdmin: 'Korisnik će biti sistemski administrator. Nastaviti?',
  copyInvitationLink: 'Kopiraj link pozivnice u međuspremnik',
  copyInvitationLinkConfirmMessage: `Ako pozvani korisnik nije primio nijednu e-poruku na adresu {{email}},
možete kopirati link pozivnice u međuspremnik i podijeliti ga sa njim na druge načine.

Kopirati link pozivnice u međuspremnik?`,
  copyPasswordResetLink: 'Kopirati link za ponovno postavljanje lozinke u međuspremnik?',
  copyPasswordResetLinkConfirmMessage: `Ako je korisnik zatražio ponovno postavljanje lozinke, ali nije primio nijednu e-poruku na adresu {{email}},
možete kopirati link za ponovno postavljanje lozinke u međuspremnik i podijeliti ga sa njim na druge načine.

Kopirati link za ponovno postavljanje lozinke u međuspremnik?`,
  editSurveyUserExtraPropsForUser: 'Uredi dodatna svojstva korisnika istraživanja za korisnika "{{userName}}"',
  inviteUser: 'Pozovi',
  invitationExpiredClickToSendAgainTheInvitation: 'Pozivnica je istekla: kliknite da ponovo pošaljete pozivnicu',
  invitationLinkCopiedToClipboard: 'Link pozivnice je kopiran u međuspremnik',
  invitedBy: 'Pozvao/la',
  invitedDate: 'Datum poziva',
  lastLogin: 'Posljednja prijava',
  moreThan30DaysAgo: 'Prije više od 30 dana',
  notAcceptedYet: 'Pozivnica još nije prihvaćena',
  passwordResetLinkCopiedToClipboard: 'Link za ponovno postavljanje lozinke je kopiran u međuspremnik',
  passwordResetLink: 'Link za ponovno postavljanje lozinke',
  prefs: {
    title: 'Postavke obavještenja',
    notifyOnUserAccessRequest: 'Novi zahtjevi korisnika za pristup',
  },
  roleInCurrentSurvey: 'Uloga u trenutnom istraživanju',
  roleInSurvey: 'Uloga u istraživanju',
  filterPlaceholder: 'Filtriraj po imenu ili e-mail adresi',
  surveyName: 'Naziv istraživanja',
  surveyExtraProp: {
    label: 'Dodatno svojstvo istraživanja',
    label_few: 'Dodatna svojstva istraživanja',
    label_other: 'Dodatna svojstva istraživanja',
  },
  surveysDraft: 'Istraživanja (nacrt)',
  surveysPublished: 'Istraživanja (objavljena)',
  userRemovedFromSurveyGoToSurveysRequired: `Uklonjeni ste iz ovog istraživanja.
Pritisnite Idi na istraživanja da otvorite listu istraživanja.`,
  userRoleUpdatedRefreshRequired: `Vaša uloga u ovom istraživanju je ažurirana.
$t(common.pressRefreshToReloadPage)`,
  userGroup: {
    new: 'Nova grupa',
    edit: 'Uredi grupu',
    name: 'Naziv',
    label: 'Oznaka',
    qualifier: 'Kvalifikator {{index}}',
    qualifier_other: 'Kvalifikatori',
    qualifierKey: 'Ključ',
    qualifierValue: 'Vrijednost',
    addQualifier: 'Dodaj kvalifikator',
    members: 'Članovi',
    addMember: 'Dodaj člana',
    noMembers: 'Još nema članova',
    memberAlreadyInGroup: 'Trenutno u grupi "{{groupName}}"',
    tabs: {
      groups: 'Korisničke grupe',
      assignments: 'Dodjele grupa',
      report: 'Izvještaj o članovima',
    },
    memberName: 'Ime člana',
    memberEmail: 'E-mail člana',
    memberRole: 'Uloga u istraživanju',
    memberStatus: 'Status',
    status: {
      INVITED: 'Pozvan',
      ACCEPTED: 'Prihvaćeno',
      FORCE_CHANGE_PASSWORD: 'Potrebna promjena lozinke',
    },
    unassigned: 'Nedodijeljeni',
    confirmDelete: 'Obrisati grupu "{{name}}"? Njeni članovi će postati nedodijeljeni. Nastaviti?',
    deleteConfirmed: 'Grupa "{{name}}" je obrisana',
    saveConfirmed: 'Grupa "{{name}}" je sačuvana',
    confirmReassign: '{{userName}} je trenutno u grupi "{{groupName}}". Premjestiti ga/je u ovu grupu?',
    notFound: 'Grupa nije pronađena',
    readableGroups: 'Može da pregleda zapise grupa',
    readableGroupsInfo:
      'Članovi ove grupe mogu da pregledaju, izvoze i preuzimaju (i u Arena Mobile) zapise izabranih grupa, ali ne mogu da ih mijenjaju',
  },
  updateUserConfirmation: 'Korisnik {{name}} je ažuriran',
  userNotInvitedToAnySurvey: `Korisnik nije pozvan ni u jedno istraživanje`,
  userSurveys: 'Istraživanja korisnika',
  usersBackup: {
    menu: 'Rezervna kopija / Vraćanje',
    backup: 'Napravi rezervnu kopiju korisnika',
    backupTitle: 'Rezervna kopija korisnika',
    backupInfo:
      'Svi korisnici biće izvezeni sa svojim ulogama u istraživanjima i korisničkim grupama, kako bi mogli biti vraćeni na drugi Arena server. 2FA uređaji se ne izvoze.',
    includePasswords: 'Uključi lozinke',
    passwordsWarning:
      'Fajl rezervne kopije sadržaće heševe lozinki: čuvajte ga na sigurnom mjestu i obrišite ga nakon upotrebe.',
    restore: 'Vrati korisnike',
    restoreTitle: 'Vrati korisnike iz rezervne kopije',
    restoreInfo: `- Korisnici se uparuju po e-mail adresi
- Uloge u istraživanjima i korisničke grupe uparuju se po nazivu istraživanja i nazivu grupe
- Uloge i korisničke grupe istraživanja koja ne postoje na ovom serveru se zanemaruju
- Nakon pritiska na "Vrati korisnike", možete izabrati šta da uradite sa svakim korisnikom`,
    backupFileInfo: 'Rezervnu kopiju napravio/la {{email}} dana {{date}} (server: {{serverUrl}})',
    passwordsNotIncluded:
      'Lozinke nisu uključene u ovu rezervnu kopiju: novi korisnici moraće ponovo da postave svoju lozinku',
    allNewUsers: 'Svi novi korisnici ({{count}})',
    allExistingUsers: 'Svi postojeći korisnici ({{count}})',
    userStatus: 'Status',
    userActionHeader: 'Radnja',
    userNew: 'Novi',
    userExisting: 'Postojeći',
    userAction: {
      insert: 'Dodaj',
      skip: 'Preskoči',
      updateRoles: 'Ažuriraj uloge u istraživanjima',
      updateAll: 'Ažuriraj uloge u istraživanjima i detalje',
    },
    sysAdmin: 'Sist. admin',
    restorePassword: 'Lozinka',
    restorePasswordInfo:
      'Vrati lozinku sačuvanu u rezervnoj kopiji (samo pri dodavanju korisnika ili ažuriranju njegovih detalja)',
    userActionShort: {
      insert: 'Dodaj',
      skip: 'Preskoči',
      updateRoles: 'Uloge',
      updateAll: 'Uloge + detalji',
    },
    details: {
      survey: 'Istraživanje',
      roleInBackup: 'Uloga u rezervnoj kopiji',
      currentRole: 'Trenutna uloga',
      notFoundInThisServer: '(nije pronađeno na ovom serveru)',
      userGroup: 'Korisnička grupa',
      inBackup: 'U rezervnoj kopiji',
      currentMember: 'Trenutni član',
    },
    summaryImported: 'Korisnici vraćeni',
    summary: {
      usersTotal: 'Korisnika u rezervnoj kopiji: {{count}}',
      usersInserted: 'Novih korisnika: {{count}}',
      usersUpdated: 'Ažuriranih korisnika: {{count}}',
      usersSkipped: 'Preskočenih korisnika: {{count}}',
      authGroupsAdded: 'Dodatih uloga u istraživanjima: {{count}}',
      userGroupsAdded: 'Dodatih članstava u korisničkim grupama: {{count}}',
    },
    surveysNotFound: 'Istraživanja nisu pronađena (uloge zanemarene): {{names}}',
    userGroupsNotFound: 'Korisničke grupe nisu pronađene (članstva zanemarena): {{names}}',
  },
}
